import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';

import get from 'lodash.get';
import { StripeProvider, Elements } from 'react-stripe-elements';

import { Message, Loader } from 'semantic-ui-react';
import MakePaymentForm from '../payment/checkoutForm';
import MakeRecurringPaymentForm from '../payment/recurringCheckoutForm';
import DonatePaymentTypeSelect from '../payment/donatePaymentTypeSelect';
import BankAccountMakePaymentForm from '../payment/bankAccountCheckoutForm';
import PledgeMakePaymentForm from '../payment/pledgeCheckoutForm';
import RecurringBankAccountMakePaymentForm from '../payment/recurringBankAccountCheckoutForm';

import { donationPaymentType } from '../../../constants/donationTypeOptions';
import { TrackerNames } from '../../../constants/webTracking';
import { STRIPE_PUBLIC_KEY } from "../../../env";

export class PaymentTabContainer extends Component {
    _mounted = false;
    state = {
        stripe: null
    }

    componentDidMount() {
        this._mounted = true;
        if (typeof window != 'undefined') {
            const stripeJs = document.createElement('script');
            stripeJs.src = "https://js.stripe.com/v3/";
            stripeJs.async = true;
            stripeJs.onload = () => {
                if (this._mounted) {
                    const stripe = window.Stripe(STRIPE_PUBLIC_KEY, {
                        stripeAccount: this.props.paymentPlatforms?.main?.accountKey,
                    });
                    this.setState({
                        stripe: stripe
                    });
                }
            };
            stripeJs.onerror = () => {
                this.setState({
                    stripe: null
                })
            }
            document.body && document.body.appendChild(stripeJs);
        }
        else {
            this.setState({
                stripe: null
            })
        }
        window.scrollTo(0, 0);

        ReactGA.pageview(window.location.pathname, [TrackerNames.clientTrackerName]);
    }

    componentWillUnmount() {
        this._mounted = false;
    }

    getFormFonts() {
        return [{ cssSrc: "https://fonts.googleapis.com/css?family=Lato" }];
    }

    render() {
        return (
            <React.Fragment>
                {
                    !this._mounted &&
                    <Loader active inline className="centered" />
                }
                {
                    <DonatePaymentTypeSelect />
                }
                <div className="payment-content">
                    {
                        this.state.stripe &&
                        <StripeProvider stripe={this.state.stripe}>
                            <Elements fonts={this.getFormFonts()}>
                                <React.Fragment>
                                    {
                                        !this.props.isRecurring && this.props.paymentType === donationPaymentType.creditCard.value &&
                                        <MakePaymentForm />
                                    }
                                    {
                                        !this.props.isRecurring && this.props.paymentType === donationPaymentType.bankAccount.value &&
                                        <BankAccountMakePaymentForm />
                                    }
                                    {
                                        this.props.isRecurring && this.props.paymentType === donationPaymentType.creditCard.value &&
                                        <MakeRecurringPaymentForm />
                                    }
                                    {
                                        this.props.isRecurring && this.props.paymentType === donationPaymentType.bankAccount.value &&
                                        <RecurringBankAccountMakePaymentForm />
                                    }
                                    {
                                        !this.props.isRecurring && this.props.paymentType === donationPaymentType.pledge.value &&
                                        <PledgeMakePaymentForm />
                                    }
                                </React.Fragment>
                            </Elements>
                        </StripeProvider>
                    }
                    {
                        !this.state.stripe && this._mounted &&
                        <Message negative onDismiss={this.handleDismiss}>
                            <Message.Header>
                                We're sorry. Donation can not be made at the time.
                        </Message.Header>
                            <p className="error">
                                Our team is already working on fixing the issue.
                        </p>
                        </Message>
                    }
                </div>
            </React.Fragment>
        );
    }
}

const mapState = state => {
    return {
        isRecurring: get(state, 'donation.subscription.enabled'),
        paymentType: get(state, 'donation.paymentType'),
        paymentPlatforms: get(state, 'page.campaign.paymentPlatforms'),
    }
}

const PaymentTab = connect(mapState)(PaymentTabContainer);
export default PaymentTab;
